import {
  externalCalendarEventsQueryKey,
  useExternalCalendarEventsQueryConfig,
} from '@griply/hooks';
import { User } from '@griply/types';
import { getUserTimeZone } from '@griply/utils';
import { useQuery } from '@tanstack/react-query';
import { getExternalCalendarEvents } from 'shared/services/backend-api';
import { getErrorReporter } from 'shared/services/error-tracking';

import { useUserQuery } from './use-user-query';

export const queryKey = externalCalendarEventsQueryKey;

const selectChangedAtMillis = (user: User | null | undefined) =>
  user?.externalCalendarEventsChangedAt?.getTime() ?? 0;

const onFetchError = (error: unknown) =>
  getErrorReporter().captureException(error, {
    tags: { source: 'external-calendar-get-events' },
  });

export const useExternalCalendarEventsQuery = (
  startDate: string,
  endDate: string,
) => {
  const { data: changedAt } = useUserQuery({ select: selectChangedAtMillis });
  const { data: timezone = getUserTimeZone() } = useUserQuery({
    select: getUserTimeZone,
  });

  return useQuery(
    useExternalCalendarEventsQueryConfig({
      startDate,
      endDate,
      timezone,
      changedAtMillis: changedAt ?? 0,
      fetchEvents: getExternalCalendarEvents,
      onFetchError,
    }),
  );
};
